export const HUBSPOT_URL_BASE = process.env.HUBSPOT_URL_BASE
export const MARKETING_FORM_URL = process.env.MARKETING_FORM_URL

export const HUBSPOT_FORM_PRIVATE_APP_TOKEN =
  process.env.HUBSPOT_FORM_PRIVATE_APP_TOKEN

export const SIGNUP_FORM_ID = process.env.SIGNUP_FORM_ID
export const EDIT_ACCOUNT_DETAILS_FORM_ID =
  '0c4cdca3-052b-468e-b60e-9a5192593521'

export const HUBSPOT_AUTH_HEADERS = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${HUBSPOT_FORM_PRIVATE_APP_TOKEN}`,
  },
}

export const COMPANY_PROPERTIES = [
  'name',
  'hubspot_owner_id',
  'company_owner_picture',
]

export const DEALS_PROPERTIES = [
  'bypass_uop',
  'dealstage',
  'dealname',
  'closedate',
  'pipeline',
  'amount',
  'hubspot_owner_id',
  'createdate',
  'closedwondate',
  'closedlostdate',
  'hs_num_of_associated_line_items',
  'artwork_approved',
  'dealtype',
  'deal_currency_code',
  'cin7_so',
  'xero_invoice_number',
  'shipping_country',
  'shipping_city',
  'shipping_state_region',
  'shipping_postal_code',
  'shipping_street_address',
  'shipping_first_name',
  'shipping_last_name',
  'shipping_phone',
  'shipping_email',

  'billing_country',
  'billing_city',
  'billing_state_region',
  'billing_postal_code',
  'billing_street_address',
  'billing_first_name',
  'billing_last_name',
  'billing_phone',
  'billing_email',

  'carrier',
  'estimated_arrival',
  'tracking_number',
  'big_commerce_order_id',
]

export const LINE_ITEM_PROPS = [
  'createdate',
  'description',
  'hs_lastmodifieddate',
  'hs_object_id',
  'hs_sku',
  'hs_url',
  'hs_images',
  'quantity',
  'price',
  'hs_product_id',
  'name',
  'artwork_urls',
  'hs_cost_of_goods_sold',
  'amount',
]

export const QUOTE_PROPS = [
  'hs_createdate',
  'hs_expiration_date',
  'hs_quote_amount',
  'hs_quote_number',
  'hs_status',
  'hs_terms',
  'hs_title',
  'hubspot_owner_id',
]
